export default "__VITE_ASSET__d9f19669__"